import { inject } from '@angular/core';
import { CanActivateFn, CanDeactivateFn } from '@angular/router';
import { AlertController, AlertOptions, NavController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { AudioCallService } from '@services/audio-call.service';
import { ConnectAudioService } from '@services/connect-audio.service';

export const audioCallCanActivate: CanActivateFn = async (): Promise<boolean> => {
  const audioCallService: AudioCallService = inject(AudioCallService);
  const navController: NavController = inject(NavController);

  if (audioCallService.hasActiveAudioCall()) {
    return true;
  }

  console.warn('No active audio call. Redirecting to calls');
  await navController.navigateBack('/calls', {replaceUrl: true});
  return false;
};

export const audioCallCanDeactivate: CanDeactivateFn<unknown> = async (): Promise<boolean> => {
  const connectAudioService: ConnectAudioService = inject(ConnectAudioService);
  const translate: TranslateService = inject(TranslateService);
  const alertController: AlertController = inject(AlertController);

  if (connectAudioService.stopAccessSubject.value) return true;

  const opts: AlertOptions = {
    header: translate.instant('call.audioCall.alerts.stopCall.header'),
    message: translate.instant('call.audioCall.alerts.stopCall.message'),
    backdropDismiss: false,
    buttons: [
      {
        text: translate.instant('call.audioCall.alerts.stopCall.buttons.cancel'),
        role: 'cancel',
      },
      {
        text: translate.instant('call.audioCall.alerts.stopCall.buttons.confirm'),
        role: 'confirm',
        handler: (): void => {
          connectAudioService.stopAccessSubject.next(true);
          connectAudioService.stopStreamSubject.next(true);
        }
      }
    ]
  };
  const alert: HTMLIonAlertElement = await alertController.create(opts);
  await alert.present();
  const result = await alert.onDidDismiss();
  return result.role === 'confirm';
};
